import React from 'react';

export const HowItWorksHero = () => {
  return (
    <>
      {/* How It Works */}
      <div
        style={{
          position: 'absolute',
          left: 537,
          top: 820,
          width: 380,
          height: 76,
          fontFamily: `'SF Pro', sans-serif`,
          fontStyle: 'normal',
          fontWeight: 510,
          fontSize: 64,
          lineHeight: '76px',
          color: '#FFFFFF',
        }}
      >
        How It Works
      </div>

      {/* Underline */}
      <div
        style={{
          position: 'absolute',
          left: 540,
          top: 900,
          width: 359,
          height: 8,
          background: 'linear-gradient(90deg, #6D1D7D 0%, #5F0BE8 100%)',
          borderRadius: 50,
        }}
      />

      {/* Subtitle */}
      <div
        style={{
          position: 'absolute',
          left: 527,
          top: 925,
          width: 385,
          height: 141,
          fontFamily: `'SF Pro', sans-serif`,
          fontStyle: 'normal',
          fontWeight: 510,
          fontSize: 24,
          lineHeight: '29px',
          textAlign: 'center',
          color: 'rgba(255, 255, 255, 0.6)',
        }}
      >
        Simple, fast and powerful chart analysis in three steps
      </div>
    </>
  );
};